__turbopack_context__.v({
  "enter": "styles-module-scss-module__L9oYGa__enter",
  "exit": "styles-module-scss-module__L9oYGa__exit",
  "fade-in": "styles-module-scss-module__L9oYGa__fade-in",
  "fade-out": "styles-module-scss-module__L9oYGa__fade-out",
  "fade-out-80": "styles-module-scss-module__L9oYGa__fade-out-80",
  "left": "styles-module-scss-module__L9oYGa__left",
  "panel": "styles-module-scss-module__L9oYGa__panel",
  "panelTitle": "styles-module-scss-module__L9oYGa__panelTitle",
  "right": "styles-module-scss-module__L9oYGa__right",
  "sidebarGrid": "styles-module-scss-module__L9oYGa__sidebarGrid",
  "slide-in-from-bottom": "styles-module-scss-module__L9oYGa__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__L9oYGa__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__L9oYGa__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__L9oYGa__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__L9oYGa__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__L9oYGa__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__L9oYGa__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__L9oYGa__slide-out-to-top",
  "topbarGrid": "styles-module-scss-module__L9oYGa__topbarGrid",
  "zoom-in": "styles-module-scss-module__L9oYGa__zoom-in",
  "zoom-out": "styles-module-scss-module__L9oYGa__zoom-out",
});
